import { render, staticRenderFns } from "./Astrapay.vue?vue&type=template&id=6818ec1e&lang=html"
import script from "./Astrapay.vue?vue&type=script&lang=js"
export * from "./Astrapay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports